// removed by extract-text-webpack-plugin
module.exports = {"treeWrapperTreeOnly":"payment-tree__treeWrapperTreeOnly-2ek2p content__treeWrapperTreeOnly-398H7"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/additional-parameters/content/payment-tree/payment-tree.css
// module id = 803
// module chunks = 0